import {keyMirror} from 'utils/DBUtils';
import {filterOptionsFactory} from './factories';

export const Types = keyMirror({
  TOGGLE_SORT_FOR_RESOURCE: null,
  ADD_FILTER_FOR_RESOURCE: null,
  REMOVE_FILTER_FOR_RESOURCE: null,
  REPLACE_FILTER_FOR_RESOURCE: null,
  SET_RAW_FILTERS_FOR_RESOURCE: null,
  REMOVE_ALL_FILTERS_FOR_RESOURCE: null
});

export const toggleSortForResourceAction = (type, field, params) => ({
  type: Types.TOGGLE_SORT_FOR_RESOURCE,
  resourceType: type,
  field: field,
  params: params || {}
});

export const addFilterForResourceAction = (type, name) => ({
  type: Types.ADD_FILTER_FOR_RESOURCE,
  resourceType: type,
  name: name
});

export const removeFilterForResourceAction = (type, name) => ({
  type: Types.REMOVE_FILTER_FOR_RESOURCE,
  resourceType: type,
  name: name
});

export const replaceFilterForResourceAction = (type, toRemove, replaceWith, params) => ({
  type: Types.REPLACE_FILTER_FOR_RESOURCE,
  resourceType: type,
  toRemove: toRemove,
  replaceWith: replaceWith,
  params: params || {}
});

export const setRawFiltersForResourceAction = (type, filters, params) => ({
  type: Types.SET_RAW_FILTERS_FOR_RESOURCE,
  resourceType: type,
  filters: filters,
  params: params || {}
});

// pass in sortOptions since we want to preserve those
export const removeAllFiltersForResourceAction = (type, sortOptions) => ({
  type: Types.REMOVE_ALL_FILTERS_FOR_RESOURCE,
  resourceType: type,
  sortOptions: sortOptions,
  filterOptions: filterOptionsFactory()
});



// WEBPACK FOOTER //
// ./public/viewOptions/actions.js